module.exports = __webpack_public_path__ + "img/im_scrollfeature_12.9a089284.jpg";